import { zod } from '@acme/core'
import { z } from 'zod'

import dayjs from 'dayjs'
import ApiService from '../api.service'

export type CompensacaoDia = z.infer<typeof zod.CompensacaoDiaSchema>

export const createCompensacaoFeriadoSchema = zod.CompensacaoDiaSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    dataCompensacao: true,
    dataFeriado: true,
    tipo: true,
})
    .extend({
        dataCompensacao: z.date().or(z.string().nonempty('Obrigatório')),
        dataFeriado: z.date().or(z.string().nonempty('Obrigatório')),
        tipo: z.literal('FERIADO').default('FERIADO'),
    })
    .refine(
        data =>
            !dayjs(data.dataCompensacao).isSame(dayjs(data.dataFeriado), 'day'),
        {
            message:
                'A data de compensação deve ser diferente da data do feriado',
            path: ['dataCompensacao'],
        },
    )

export const createCompensacaoFolgaSchema = zod.CompensacaoDiaSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    dataCompensacao: true,
    dataFeriado: true,
    tipo: true,
})
    .extend({
        dataCompensacao: z.date().or(z.string().nonempty('Obrigatório')),
        dataFeriado: z.date().or(z.string().nonempty('Obrigatório')),
        tipo: z.literal('FOLGA').default('FOLGA'),
    })
    .refine(
        data =>
            !dayjs(data.dataCompensacao).isSame(dayjs(data.dataFeriado), 'day'),
        {
            message:
                'A data de compensação deve ser diferente da data da folga',
            path: ['dataCompensacao'],
        },
    )

/**
 * @usage softDelete
 */
export const compensacaoFeriados = new ApiService<CompensacaoDia>(
    'compensacao-feriados',
)

export const compensacaoFolgas = new ApiService<CompensacaoDia>(
    'compensacao-folgas',
)
